<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="container">
        <div class="uinfo clearfix">
          <div class="mask l"><img :src="detail.coverUrl+$resize(200,200)"/></div>
          <div class="cont l">
            <div class="topbar clearfix">
              <div class="l">
                <span class="nickname">{{detail.name}}</span>
                <span class="auth" v-if="detail.isProducer == 1"></span>
                <span class="sex blue" v-if="detail.gender == 1">男</span>
                <span class="sex red"  v-if="detail.gender == 2">女</span>
                <span class="type bgyellow" v-if="detail.favouriteType==1">演员</span>
                <span class="type bgblue" v-if="detail.favouriteType==2">KOL</span>
                <span class="type bgred" v-if="detail.favouriteType==3">配音</span>
              </div>
              <div class="buttons r" v-if="isme" style="position: relative;">
                <button class="btn btn-empty" v-if="detail.isProducer == 0" @click="toAuth()">制作人认证</button>
                <button class="btn bgyellow" v-if="detail.isProducer == 1" @click="toAuth()">已认证</button>
                <button class="btn bgorange" v-if="detail.isProducer == 2">认证审核中</button>
                <button class="btn bgred" v-if="detail.isProducer == 3" @click="toAuth()">认证失败</button>

                <div v-if="produceAuthMsg" style="position: absolute; right: 0; bottom: -35px; width: 200px; color: #FF4C4C">*未满3个月不可以重新进行认证</div>
              </div>
              <div class="keep" v-else>
                <button class="btn btn-empty btn-collect r" v-if="!detail.isKeep" @click="onKeep"><i></i>收藏</button>
                <button class="btn btn-empty btn-collect r ed" v-if="detail.isKeep" @click="onKeep"><i></i>已收藏</button>
              </div>
            </div>
            <div class="summary" v-if="detail.favouriteType == 3">{{detail.summary?detail.summary:'未填写'}}</div>
            <div class="baseinfo clearfix">
              <div class="l" v-if="detail.favouriteType == 1">
                <span>职业：</span>
                <span>{{detail.modelOrActor?detail.modelOrActor:'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 1">
                <span>类别：</span>
                <span>{{detail.type?getPalentType(detail.type):'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 1 || detail.favouriteType == 2">
                <span>生日：</span>
                <span>{{(detail.birth?detail.birth:'未填写')|formatDate}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 2">
                <span>星座：</span>
                <span>{{detail.constellation?detail.constellation:'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 2">
                <span>所在城市：</span>
                <span>{{detail.city?detail.city:'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 1 || detail.favouriteType == 2">
                <span>身高：</span>
                <span>{{detail.height?detail.height+'cm':'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 1 || detail.favouriteType == 2">
                <span>体重：</span>
                <span>{{detail.weight?detail.weight+'kg':'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 1">
                <span>三围：</span>
                <span>{{detail.bust?(detail.bust+'cm,'+detail.buttLine+'cm,'+detail.waistLine+'cm'):'未填写'}}</span>
              </div>
              <div class="l" v-if="detail.favouriteType == 2">
                <span>特长：</span>
                <span>{{detail.skill?detail.skill:'未填写'}}</span>
              </div>
            </div>
            <div class="opera"><a class="btn btn-default" href="publish.html" style="width: 116px;">邀请制片</a></div>
          </div>
        </div>

        <div class="tabsbar clearfix">
          <div class="tabs l">
            <span class="tab" :class="{on: currTab == 1}" @click="onTabPanel(1)" v-if="detail.favouriteType !=3">美图</span>
            <span class="tab" :class="{on: currTab == 2}" @click="onTabPanel(2)">视频作品</span>
            <span class="tab" :class="{on: currTab == 3}" @click="onTabPanel(3)" v-if="detail.favouriteType !=3">资料</span>
            <span class="tab" :class="{on: currTab == 4}" @click="onTabPanel(4)" v-if="isme">认证信息</span>
            <span class="tab" :class="{on: currTab == 5}" @click="onTabPanel(5)" v-if="isme && detail.isProducer == 1">服务协议</span>
          </div>
          <div class="opera r">
            <div class="btns" v-if="currTab == 1 && isme">
              <button class="btn btn-default btn-w100" v-if="!imglist.length && (detail.photoStatus == 0 || detail.photoStatus == 2)" @click="onEditPhoto()"><i class="icon icon1"></i>上传美图</button>
              <button class="btn btn-default btn-w100" v-if="imglist.length && (detail.photoStatus == 0 || detail.photoStatus == 2)" @click="onEditPhoto()"><i class="icon icon5"></i>编辑美图</button>
              <button class="btn btn-default bggreen" v-if="detail.photoStatus == 1" @click="onEditPhoto()">审核中</button>
              <button class="btn btn-default bgred" v-if="detail.photoStatus == 3" @click="onEditPhoto()">审核失败</button>
            </div>
            <div class="btns" v-if="currTab == 2">
              <div class="search">
                <input type="text" :placeholder="search.text" v-model="search.value" maxlength="20"/><a class="" @click="onSearch"></a>
              </div>
              <button class="btn btn-default btn-w100" @click="toPublish()" v-if="isme"><i class="icon icon2"></i>发布作品</button>
            </div>
            <div class="btns" v-if="currTab == 3 && isme">
              <button class="btn btn-default btn-w100" v-show="!editData.state" @click="onEditData()"><i class="icon icon5"></i>修改资料</button>
              <button class="btn btn-default" v-show="editData.state" @click="onSaveData()"  style="margin-right: 20px;">保存</button>
              <button class="btn btn-default" v-show="editData.state" @click="onEditData()">取消</button>
            </div>
          </div>
        </div>

        <div class="panels">
          <div>
            <div class="empty" v-show="!imglist.length && currTab == 1">
              <img src="../../assets/images/544.png">
              <div v-if="!isme">
                <p class="etitle">这个人太低调了，还没有上传美图</p>
                <p>去看看其他内容吧～</p>
              </div>
              <div v-if="isme">
                <p class="etitle">您还没有上传美图哦～</p>
                <p>发布靓照向大家展示自己风采吧</p>
              </div>
            </div>

            <div class="empty" v-show="defaultPanel.panel2">
              <img src="../../assets/images/546.png">
              <p>没有搜索到相关内容，换个关键词试试</p>
            </div>

            <div class="empty" v-show="defaultPanel.panel1 && currTab == 2 && !defaultPanel.panel2">
              <img src="../../assets/images/547.png">
              <div v-if="!isme">
                <p class="etitle">这个人太低调了，还没有发布作品</p>
                <p>去看看其他内容吧～</p>
              </div>
              <div v-if="isme">
                <p class="etitle">您还没有上传作品哦～</p>
                <p>你若您有作品可用于展示，可发布作品，提升接单率</p>
              </div>
            </div>
          </div>

          <div class="panel" v-show="currTab == 1">
            <div class="photo">
              <div class="img" v-for="item in imglist">
                <img :src="item+$resize(277,480)">
              </div>
            </div>
          </div>

          <div class="panel" v-show="currTab == 2 && (caselist.length || Object.keys(topcase).length)">
            <div class="topping clearfix" v-if="Object.keys(topcase).length" v-show="!search.value">
              <div class="img l">
                <a :href="'caseDe.html?id='+topcase.id">
                  <img :src="topcase.coverUrl+$resize(790,474)"/>
                </a>
                <span class="length">{{topcase.videoLength}}</span>
              </div>
              <div class="info-box r">
                <div class="info">
                  <div class="h2">{{topcase.title}}</div>
                  <div class="date"><span class="ident" v-if="isme"><i class="icon"></i>置顶作品</span>发布时间：{{topcase.addTime|formatDate}}</div>
                  <ul class="tag clearfix">
                    <li v-for="ys in topcase.typeStr"><span>{{ys}}</span></li>
                  </ul>
                  <div class="summary">{{topcase.description}}</div>
                </div>

                <div class="opera" v-if="isme&&topcase.checkStatus != 0">
                  <a :href="'publication.html?edit='+topcase.id" class="edit">编辑</a>
                  <a @click="onDelWork(topcase)" class="delete">删除</a>
                </div>
              </div>
            </div>

            <div class="list clearfix">
              <div class="case l" v-for="item in caselist" >
                <div class="imgbox">
                  <a :href="'caseDe.html?id='+item.id" target="_blank">
                    <div class="img">
                      <img :src="item.coverUrl+$resize(380,214)"/>
                      <span class="length">{{item.videoLength}}</span>
                    </div>
                    <div class="bg summary" v-if="item.checkStatus == 1">
                      <p>{{item.description}}</p>
                    </div>
                  </a>
                  <div class="bg state" v-if="item.checkStatus != 1">
                    <p class="audit" v-if="item.checkStatus == 0"><i class="icon"></i>审核中</p>
                    <p class="fail" v-if="item.checkStatus == 2"><i class="icon"></i>审核失败</p>
                    <p v-if="item.checkStatus == 2" style="padding: 0 35px; margin-top: 15px; font-size: 12px;">{{item.checkMsg}}</p>
                  </div>
                </div>

                <div class="info-box">
                  <div class="info">
                    <div class="h3">{{item.title}}</div>
                    <ul class="tag clearfix">
                      <li class="l" v-for="(ys,index) in item.typeStr" v-if="index<3"><span>{{ys}}</span></li>
                    </ul>
                  </div>

                  <div class="date">
                    <span>{{item.addTime|formatDate}}</span>
                    <div class="opera r" v-if="isme&&item.checkStatus != 0">
                      <a @click="onSetTop(item.id)" v-if="item.checkStatus == 1">置顶</a>
                      <a :href="'publication.html?edit='+item.id">编辑</a>
                      <a class="delete" @click="onDelWork(item)">删除</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pages" v-if="totalPage/pageSize>1">
              <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
            </div>
          </div>

          <div class="panel" v-show="currTab == 3">
            <div v-if="detail.favouriteType == 1">
              <div class="data clearfix" v-show="!editData.state">
                <div class="l left">
                  <div class="ain">
                    <div class="title"><span>个人介绍</span></div>
                    <div class="cont">{{detail.summary?detail.summary:'未填写'}}</div>
                  </div>

                  <div class="base">
                    <div class="title"><span>基本信息</span></div>
                    <div class="cont clearfix">
                      <div class="div50 l">
                        <div><span>身高</span>{{detail.height?detail.height+'cm':'未填写'}}</div>
                        <div><span>胸围</span>{{detail.bust?detail.bust+'cm':'未填写'}}</div>
                        <div><span>腰围</span>{{detail.waistLine?detail.waistLine+'cm':'未填写'}}</div>
                        <div><span>臀围</span>{{detail.buttLine?detail.buttLine+'cm':'未填写'}}</div>
                      </div>

                      <div class="div50 r">
                        <div><span>体重</span>{{detail.weight?detail.weight+'kg':'未填写'}}</div>
                        <div><span>生日</span>{{(detail.birth?detail.birth:'未填写')|formatDate}}</div>
                        <div><span>星座</span>{{detail.constellation?detail.constellation:'未填写'}}</div>
                        <div><span>特长</span>{{detail.skill?detail.skill:'未填写'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="r right">
                  <div class="works">
                    <div class="title"><span>作品信息</span></div>
                    <div class="cont">
                      <div class="item" v-for="item in worklist">
                        <div class="wt">《{{item[0]}}》</div>
                        <div class="wb clearfix">
                          <div><span>饰演：</span>{{item[1]}}</div>
                          <div><span>导演：</span>{{item[2]}}</div>
                          <div><span>作品类型：</span>{{item[3]}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="data clearfix" v-show="editData.state">
                <div class="l left">
                  <div class="ain">
                    <div class="title">
                      <span>个人介绍</span>
                      <span class="tips">如需修改，请前往认证信息模块</span>
                    </div>
                    <div class="cont">{{detail.summary?detail.summary:'未填写'}}</div>
                  </div>

                  <div class="base">
                    <div class="title"><span>基本信息</span></div>
                    <div class="cont clearfix">
                      <div class="l">
                        <div>
                          <span>身高:</span>
                          <input type="text" v-model="editData.form.height" maxlength="3"/> cm
                        </div>
                        <div>
                          <span>胸围:</span>
                          <input type="text" v-model="editData.form.bust" maxlength="3"/> cm
                        </div>
                        <div>
                          <span>腰围:</span>
                          <input type="text" v-model="editData.form.waistLine" maxlength="3"/> cm
                        </div>
                        <div>
                          <span>臀围:</span>
                          <input type="text" v-model="editData.form.buttLine" maxlength="3"/> cm
                        </div>
                      </div>

                      <div class="r">
                        <div>
                          <span>体重:</span>
                          <input type="text" v-model="editData.form.weight" maxlength="3"/> kg
                        </div>
                        <div class="input180">
                          <span>生日:</span>
                          <DatePicker type="date" format="yyyy-MM-dd" v-model="editData.form.birth" style="width: 180px;"></DatePicker>
                        </div>
                        <div class="input180">
                          <span>星座:</span>
                          <Select v-model="editData.form.constellation" style="width:180px">
                            <Option v-for="item in starlist" :value="item" :key="item">{{item}}</Option>
                          </Select>
                        </div>
                        <div class="input180">
                          <span>特长:</span>
                          <input type="text" v-model="editData.form.skill" maxlength="10"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="r right">
                  <div class="works">
                    <div class="title"><span>作品信息</span></div>
                    <div class="cont">
                      <div class="item" v-for="item,index in worklist">
                        <div class="wt input100"><input type="text" v-model="item[0]" maxlength="30"/></div>
                        <div class="wb clearfix">
                          <div class="inputH25"><span>饰演：</span><input type="text" v-model="item[1]" maxlength="6"/></div>
                          <div class="inputH25"><span>导演：</span><input type="text" v-model="item[2]" maxlength="6"/></div>
                          <div class="inputH25"><span>作品类型：</span><input type="text" v-model="item[3]" maxlength="6"/></div>
                        </div>
                        <span class="del" @click="onDelWorksInfo(index)"></span>
                      </div>

                      <div class="item" v-show="editData.stateAdd">
                        <div class="wt input100"><input type="text" v-model="editData.work[0]" maxlength="30"/></div>
                        <div class="wb clearfix">
                          <div class="inputH25"><span>饰演：</span><input type="text" v-model="editData.work[1]" maxlength="6"/></div>
                          <div class="inputH25"><span>导演：</span><input type="text" v-model="editData.work[2]" maxlength="6"/></div>
                          <div class="inputH25"><span>作品类型：</span><input type="text" v-model="editData.work[3]" maxlength="6"/></div>
                        </div>
                        <span class="del" @click="onDelAddWorksInfo"></span>
                      </div>
                      <div>
                        <a class="btn btn-empty empty-blue" @click="onAddWorkInfo" style="width: 160px;"><i class="icon icon3"></i>添加作品</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="detail.favouriteType == 2">
              <div class="data clearfix" v-show="!editData.state">
                <div class="l left">
                  <div class="ain">
                    <div class="title"><span>个人介绍</span></div>
                    <div class="cont">{{detail.summary?detail.summary:'未填写'}}</div>
                  </div>
                </div>
                <div class="r right">
                  <div class="base">
                    <div class="title"><span>基本信息</span></div>
                    <div class="cont clearfix">
                      <div>
                        <div><span>身高</span>{{detail.height?detail.height+'cm':'未填写'}}</div>
                        <div><span>体重</span>{{detail.weight?detail.weight+'kg':'未填写'}}</div>
                        <div><span>生日</span>{{(detail.birth?detail.birth:'未填写')|formatDate}}</div>
                        <div><span>星座</span>{{detail.constellation?detail.constellation:'未填写'}}</div>
                        <div><span>特长</span>{{detail.skill?detail.skill:'未填写'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="data clearfix" v-show="editData.state">
                <div class="l left">
                  <div class="ain">
                    <div class="title">
                      <span>个人介绍</span>
                      <span class="tips">如需修改，请前往认证信息模块</span>
                    </div>
                    <div class="cont">{{detail.summary?detail.summary:'未填写'}}</div>
                  </div>
                </div>
                <div class="r right">
                  <div class="base">
                    <div class="title"><span>基本信息</span></div>
                    <div class="cont clearfix">
                      <div>
                        <div>
                          <span>身高:</span>
                          <input type="text" v-model="editData.form.height" maxlength="3"/> cm
                        </div>
                        <div>
                          <span>体重:</span>
                          <input type="text" v-model="editData.form.weight" maxlength="3"/> kg
                        </div>
                        <div class="input180">
                          <span>生日:</span>
                          <DatePicker type="date" format="yyyy-MM-dd" v-model="editData.form.birth" style="width: 180px;"></DatePicker>
                        </div>
                        <div class="input180">
                          <span>星座:</span>
                          <Select v-model="editData.form.constellation" style="width:180px">
                            <Option v-for="item in starlist" :value="item" :key="item">{{item}}</Option>
                          </Select>
                        </div>
                        <div class="input180">
                          <span>特长:</span>
                          <input type="text" v-model="editData.form.skill" maxlength="10"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel" v-show="currTab == 4">
            <div class="pane-accinfo">
              <div class="head">
                <span>制作人资质认证</span>
                <div class="buttons r" v-if="isme" style="position: relative;">
                  <button class="btn btn-empty" v-if="detail.isProducer == 0" @click="toAuth()">制作人认证</button>
                  <button class="btn bgyellow" v-if="detail.isProducer == 1" @click="toAuth()">已认证</button>
                  <button class="btn bgorange" v-if="detail.isProducer == 2" @click="toAuth()">认证审核中</button>
                  <button class="btn bgred" v-if="detail.isProducer == 3" @click="toAuth()">认证失败</button>
                </div>
              </div>
              <div class="cont clearfix">
                <div class="l">
                  <div class="cell">
                    <span>认证类型：</span>
                    <span v-if="authInfo.favouriteType == 1">演员</span>
                    <span v-if="authInfo.favouriteType == 2">KOL</span>
                    <span v-if="authInfo.favouriteType == 3">配音</span>
                  </div>

                  <div class="cell">
                    <span>真实姓名：</span>
                    <span>{{authInfo.producerName}}</span>
                  </div>

                  <div class="cell">
                    <span>性别：</span>
                    <span v-if="authInfo.gender == 0">其他</span>
                    <span v-if="authInfo.gender == 1">男</span>
                    <span v-if="authInfo.gender == 2">女</span>
                  </div>

                  <div class="cell">
                    <span>所在城市：</span>
                    <span>{{authInfo.city}}</span>
                  </div>


                  <div class="cell">
                    <span>从业年份：</span>
                    <span>{{authInfo.joinDate}}年</span>
                  </div>
                </div>
                <div class="r">
                  <div class="cell">
                    <span>报价：</span>
                    <span>{{authInfo.fee}}/天</span>
                  </div>

                  <div class="cell">
                    <span>简介：</span>
                    <span>{{authInfo.summary}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel" v-show="currTab == 5">
            <div class="protocol">
              <div class="text">在平台接单需签署相关服务协议，请扫描下方二维码前往签署，<br/>若您已签署，也可通过下方二维码进行查询。</div>
              <div class="qrimg"><img src="../../assets/images/qr3.png"></div>
              <div class="opera">
                <button class="btn btn-empty" v-show="detail.gmSignStatus == 0">未签署</button>
                <button class="btn" v-show="detail.gmSignStatus == 1">已签署</button>
                <button class="btn red" v-show="detail.gmSignStatus == 2">已过期</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="ModalDelete.state" title="提示" class="modal" width="480" footer-hide>
      <div style="padding-bottom: 30px; font-size: 18px; text-align:center;">
        <div style="margin-top: 38px;">确定删除当前作品吗？</div>
        <div style="margin-top: 30px;">
          <Button class="btn btn-default" @click="onModalDeleteBtn()">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="ModalPhoto.state" title="编辑美图" class="modal photo" width="920" footer-hide>
      <div class="cont clearfix">
        <div class="imgs l" v-for="(item,index) in ModalPhoto.imgs">
          <div class="btn-file border">
            <img :src="item+$resize(150,266)" />
            <div class="hover">
              <button class="btn" @click="onReplacePhoto(index)"><span class="icon icon4"></span>替换</button>
              <button class="btn btn-empty" style="background: transparent;" @click="onDeletePhoto(index)"><span class="icon icon6"></span>删除</button>
            </div>
          </div>
        </div>

        <div class="imgs l">
          <div class="btn-file" id="js-addimg">
            <div class="default text">
              <i class="icon1"></i><br/>
              <span>图片</span>
            </div>
          </div>
        </div>
        <div class="img hide">
          <button id="js-repimg">替换</button>
        </div>
      </div>
      <div class="foot">
        <Button class="btn btn-default" @click="onSubmitPhoto()" style="margin-right: 20px;">提交</Button>
        <Button class="btn btn-empty" @click="onEditPhoto()">取消</Button>
      </div>
    </Modal>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'
  import { TalentApi } from '@/fetch/api';
  import { userPageApi,caseIndex,accountApi,realApi } from '@/fetch/api'
  import util from '@/util/util';
  import dict from '@/util/dict';
  import moment from 'moment'

  export default {
    components:{
      Header,Footer
    },
    data(){
      return{
        pageSize: 9, //每页条数
        totalPage: 0,  //总页数
        currPage: 1, //当前页数
        currTab: 1,
        isme: 0, //0不是  1是
        gmSignStatus: false,
        produceAuthMsg: false,
        search: {
          value: "",
          text:"搜索作品"
        },
        id: "",
        origin: "",
        detail:{},
        authInfo: {},
        imglist:[],
        worklist:[],
        caselist:[],
        topcase: {},
        ModalDelete: {
          state: false,
          id: "",
          curr: 0
        },
        ModalPhoto: {
          state: false,
          imgs: [],
        },
        editData: {
          state: false,
          stateAdd: false,
          work: [],
          form: {
          }
        },
        defaultPanel:{
          panel1:false,
          panel2:false,
        },
        starlist: dict.star,
        accuntId: '',
      }
    },
    mounted(){
      this.accuntId = this.id = util.GetQueryString("id");
      this.origin = util.GetQueryString("origin");
      if(this.origin == 1){
        this.getAuthTalentDetail();
        this.getDetail();
        this.getAuth();
      } else {
        this.getTalentDetail();
      }

      $(document).ready(()=>{
        util.ImgUpload("js-addimg",(img)=>{
          this.ModalPhoto.imgs.push(img);
        });
        util.ImgUpload("js-repimg",(img)=>{
          var subs = $("#js-repimg").data('subs');
          this.ModalPhoto.imgs.splice(subs,1,img);
        });
      })
    },
    watch:{
      search: {
        handler(){
          this.onSearch();
        },
        deep:true
      }
    },
    methods:{
      onDelAddWorksInfo(){
        this.editData.work = [];
        this.editData.stateAdd = false;
      },
      getDetail(){
        accountApi.apiAccountGetDetail().then(re=>{
          if(re.data.producerType != 3 && this.isme == 1){
              window.location.href = 'userPage.html?id='+this.id;
              return;
          }
          if(re.data.id == this.id){
            this.isme = 1;
          }

          this.$set(this.detail,'isProducer',re.data.isProducer);
          this.$set(this.detail,'gmSignStatus',re.gmSignStatus);
        });
      },
      onDelWorksInfo(val){
        this.worklist.splice(val,1);
      },
      onAddWorkInfo(){
        console.log(this.worklist.length)
        if(this.worklist.length>9){
          msgWarning('最多添加10个作品');
          return;
        }

        if(this.editData.work.length>3){
          this.worklist.push(this.editData.work);
          if(this.worklist.length>9){
            this.editData.stateAdd = false;
          }
        } else {
          this.editData.stateAdd = true;
        }
        this.editData.work = [];
      },
      onSaveData(){
        if(this.editData.work.length>3){
          this.worklist.push(this.editData.work);
          this.editData.stateAdd = false;
        } else if(this.editData.work.length>0){
          msgWarning("请把作品填写完整");
          return;
        }

        let str = "";
        this.worklist.forEach((item,index)=>{
          if((this.worklist.length-1) != index){
            str += item.toString()+';'
          } else {
            str += item.toString()
          }
        })

        this.editData.form.worksInfo = str;
        TalentApi.postFavouriteInfo(this.editData.form).then((re) => {
          if(re.status == 1){
            msgSuccess("保存成功")
            this.editData.work = [];
            this.editData.state = false;
            this.getAuthTalentDetail();
          }
        });
      },
      onEditData(){
        if(this.detail.isProducer != 1){
          msgWarning("只有认证制作人可以发布美图，你还不是制作人，请先认证。");
          return;
        }
        if(this.editData.state){
          this.editData.state = false;
        } else {
          this.editData.state = true;
        }
      },
      toAuth(){
        if(this.detail.producerAuthTime && this.detail.isProducer == 1 && (new Date().getTime() - this.detail.producerAuthTime)<7776000000){
          this.produceAuthMsg = true;
        } else {
          location.href = 'realActorInfo.html?id='+this.id+'&isProducer=3';
        }

      },
      onReplacePhoto(val){
        $("#js-repimg").data('subs',val);
        $("#js-repimg").click();
      },
      onDeletePhoto(val){
        this.ModalPhoto.imgs.splice(val,1);
      },
      onSubmitPhoto(){
        let imgs = this.ModalPhoto.imgs.toString().replace(/,/g,';');
        let params = {
          favouriteId: this.detail.id,
          photos: imgs
        };
        TalentApi.updatePhotos(params).then((re) => {
          this.ModalPhoto.state = false;
          this.getAuthTalentDetail();
        });
      },
      onCancelPhoto(){
      },
      onEditPhoto(){
        if(this.ModalPhoto.state){
          this.ModalPhoto.state = false;
        } else {
          this.ModalPhoto.state = true;
        }
      },
      getAuthTalentDetail(){
        TalentApi.getFavouriteDetail().then((re) => {
          if(!re.data){
            return;
          }
          // if(re.data.accountId == this.id){
          //   this.isme = 1;
          // }
          if(re.data.img){
            this.imglist = re.data.img.split(";");
          }
          if(re.data.imgToCheck){
            this.ModalPhoto.imgs = re.data.imgToCheck.split(";");
          }
          if(re.data.worksInfo){
            this.worklist = [];
            let arry = re.data.worksInfo.split(";");
            arry.forEach((item)=>{
              this.worklist.push(item.split(","));
            });
          }
          this.detail = re.data;
          this.editData.form = re.data;
          if(re.data.birth){
            this.editData.form.birth = moment(re.data.birth).format('YYYY-MM-DD');
          }
          if(re.data.type == 4||re.data.type == 5||re.data.type == 6||re.data.type == 7||re.data.type == 10){
            this.$set(this.detail,'favouriteType',1);
          } else if(re.data.type == 8){
            this.$set(this.detail,'favouriteType',2);
          } else if(re.data.type == 9){
            this.$set(this.detail,'favouriteType',3);
            this.onTabPanel(2)
          }
          this.$set(this.detail,'gender', this.authInfo.gender);
          this.$set(this.editData.form,'city',this.authInfo.city);
        });
      },
      onTabPanel(val){
        this.currTab = val;
        this.currPage = 1;
        this.defaultPanel.panel2 = false;
        if(val == 2){
          this.getTopProducer();
        }
      },
      onKeep(){
        let params = {
          "type": this.detail.isKeep?2:1,
          "modelId": this.id
        }

        TalentApi.modelKeep(params).then((re) => {
          if(this.detail.isKeep){
            msgSuccess("取消成功")
            this.detail.isKeep = 0;
          } else {
            msgSuccess("收藏成功")
            this.detail.isKeep = 1;
          }
        });
      },
      getTalentDetail(){
        let params = {
          "id": this.id,
        }

        TalentApi.getModelActorDetail(params).then((re) => {
          if(re.data.img){
            this.imglist = re.data.img.split(";");
          }

          this.accuntId = re.data.accountId;

          if(re.data.worksInfo){
            let arry = re.data.worksInfo.split(";");
            arry.forEach((item)=>{
              this.worklist.push(item.split(","));
            });
          }
          this.detail = re.data;

          if(re.data.type == 4||re.data.type == 5||re.data.type == 6||re.data.type == 7||re.data.type == 10){
            this.$set(this.detail,'favouriteType',1);
          } else if(re.data.type == 8){
            this.$set(this.detail,'favouriteType',2);
          } else if(re.data.type == 9){
            this.$set(this.detail,'favouriteType',3);
            this.onTabPanel(2)
          }
          this.$set(this.detail,'isProducer',1);
          this.getProducerInfo();
        });
      },
      getProducerInfo(){
        let params = {
          "accountId": this.detail.accountId
        };

        userPageApi.getProducerDetail(params).then((re) => {
          // this.produceInfo = re.data;
          this.$set(this.detail,'city',re.data.city);
        });
      },
      getPalentType(i){
        return dict.artist[i-1];
      },
      getAuth(){
        realApi.getProducerAuth().then((re) => {
          this.authInfo = re.data;
          this.$set(this.detail,'coverUrl',re.data.faceUrl);
          this.$set(this.detail,'name',re.data.producerName);
          this.$set(this.detail,'gender',re.data.gender);
          this.$set(this.detail,'summary',re.data.summary);
          this.$set(this.detail,'favouriteType',re.data.favouriteType);
          this.$set(this.detail,'city',re.data.city);
          this.$set(this.detail,'producerAuthTime',re.data.producerAuthTime);
          this.$set(this.editData.form,'city',re.data.city);
        });
      },
      toPublish(){
        if(this.detail.isProducer == 1){
          location.href = 'publication.html?id='+this.id;
        } else {
          msgWarning("只有认证制作人可以发布作品，你还不是制作人，请先认证。")
        }
      },
      onSearch(){
        this.getProducerWorks();
      },
      onPageChange(no){
        this.currPage = no;
        this.getProducerWorks();
      },
      onModalDeleteBtn(){
        userPageApi.apiAccountDeleteWorkSample({id:this.ModalDelete.id}).then(data=>{
          if(data.status === 1){
            this.ModalDelete.state = false;
            msgSuccess('删除成功！');
            this.getTopProducer();
          }
        });
      },
      onDelWork(val){
        this.ModalDelete.state = true;
        this.ModalDelete.id = val.id;
      },
      onSetTop(id){
        userPageApi.apiAccountSetTopWorkSample({id:id}).then(data=>{
          if(data.status === 1){
            msgSuccess('置顶成功！');
            this.getTopProducer();
          }else{
            msgError(data.message)
          }
        });
      },
      getTopProducer(){
        let params = {
          "accountId": this.accuntId
        };

        userPageApi.getTopSample(params).then((re) => {
          if(re.data){
            re.data.typeStr = re.data.typeStr.split(",");
          }
          this.topcase = re.data?re.data:{};
          this.getProducerWorks();
        });
      },
      getProducerWorks(){
        let params = {
          "accountId": this.accuntId,
          "name": this.search.value,
          "pageNo": this.currPage,
          "pageSize": this.pageSize
        }
        caseIndex.getWorkSampleByPage(params).then((re) => {
          if(re.list){
            re.list.forEach((item)=>{
              item.typeStr = item.typeStr.split(",");
            });
          }
          if(!re.list.length && !Object.keys(this.topcase).length){
            this.defaultPanel.panel1 = true;
          }
          if(!re.list.length && this.search.value){
            this.defaultPanel.panel2 = true;
          } else {
            this.defaultPanel.panel2 = false;
          }
          this.caselist = re.list;
          this.totalPage = re.counts;
        });
      },
    }
  }
</script>

<style scoped>
  .icon{
    margin-right: 6px;
    width: 18px;
    height: 18px;
  }
  .icon1{
    background: url('../../assets/images/542.png') no-repeat scroll center;
    background-size: 100%;
  }
  .icon2{
    margin-top: -3px;
    background-position: -633px -1207px;
  }
  .icon3{
    margin-right: 15px;
    background: url('../../assets/images/549.png') no-repeat scroll center;
    background-size: 100%;
  }
  .icon4{
    margin-top: -3px;
    background: url('../../assets/images/5412.png') no-repeat scroll center;
    background-size: 100%;
  }
  .icon5{
    margin-top: -5px;
    background: url('../../assets/images/5413.png') no-repeat scroll center;
    background-size: 100%;
  }
  .icon6{
    margin-top: -2px;
    background: url('../../assets/images/icon_11.png') no-repeat scroll center;
    background-size: 100%;
  }
  .main{
    padding: 30px 0 80px;
  }
  .data input{
    width: 100px;
    height: 32px;
    line-height: 32px;
  }
  .inputH25 input{
    width: 90px;
    height: 25px;
    line-height: 25px;
  }
  .input100 input{
    width: 100%;
  }
  .input180 input{
    width: 180px;
  }
  .btn{
    padding: 0;
    width: 85px;
    height: 35px;
    line-height: 35px;
  }
  .btn-w100{
    width: 100px;
  }
  .empty-blue{
    line-height: 33px;
    color: #70A6FF;
    border: 1px solid #70A6FF;
    border-radius: 2px;
  }
  .red{
    color: #FF5555;
    background: rgba(255,85,85,0.20);
  }
  .blue{
    color: #3E87FF;
    background: rgba(62,135,255,0.2);
  }
  .bgyellow{
    background: #FBAC00;
  }
  .bgblue{
    background: #61A9FF;
  }
  .bgorange{
    background-image: linear-gradient(-135deg, #FF6500 100%, #FFB00F 0%);
    border-radius: 2px;
  }
  .bgred{
    background: #F94C48;
    box-shadow: 0 5px 20px 0 rgba(249,76,72,0.25);
    border-radius: 2px;
  }
  .bggreen{
    background: #4ACFCC;
    box-shadow: 0 5px 20px 0 rgba(74,207,204,0.25);
    border-radius: 2px;
  }
  .uinfo{
    padding: 30px 20px;
    background: #FFFFFF;
  }
  .uinfo .mask{
    width: 200px;
    height: 200px;
  }
  .uinfo .cont{
    padding-left: 43px;
    width: 960px;
  }
  .mask img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .topbar span{
    display: inline-block;
    margin-right: 10px;
    font-size: 12px;
    vertical-align: middle;
  }
  .topbar .nickname{
    font-size: 24px;
  }
  .topbar .auth{
    width: 20px;
    height: 20px;
    background: url("../../assets/images/auth1.png") no-repeat scroll center;
  }
  .topbar .sex{
    padding: 0 9px;
    border-radius: 2px;
  }
  .topbar .type{
    padding: 1px 9px;
    color: #ffffff;
    font-size: 12px;
    border-radius: 2px;
  }

  .baseinfo{
    margin: 30px 0 40px;
    padding-right: 117px;
  }
  .baseinfo div{
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .baseinfo div:nth-child(-n+3){
    margin-bottom: 20px;
  }
  .baseinfo div:nth-child(3n){
    width: 400px;
  }
  .baseinfo span:nth-child(1){
    color: #B8B8B8;
  }
  .uinfo .summary{
    margin: 20px 0 36px;
    width: 720px;
    height: 72px;
    line-height: 24px;
    color: #838895;
    font-size: 14px;
    overflow: hidden;
  }

  .tabsbar{
    margin-bottom: 30px;
    padding: 0 20px;
    font-size: 16px;
    background: #FFFFFF;
    border-top: 1px solid #F5F5F5;
  }
  .tabsbar .tabs .tab{
    display: inline-block;
    margin-right: 60px;
    padding: 18px 0;
    cursor: pointer;
  }
  .tabsbar .tabs .tab.on{
    color: #3E87FF;
  }
  .tabsbar .opera{
    margin-top: 14px;
  }
  .search{
    display: inline-block;
    margin-right: 30px;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
  }
  .search input{
    padding: 8px 10px;
    width: 223px;
    height: 33px;
    line-height: 33px;
    vertical-align: middle;
    border: 0;
    border-radius: 4px;
  }
  .search a{
    display: inline-block;
    width: 33px;
    height: 33px;
    vertical-align: middle;
    background: transparent url("../../assets/images/sousuo.png") no-repeat scroll center;
  }

  .photo .img{
    display: inline-block;
    margin: 30px 30px 0 0;
    width: 277px;
    height: 480px;
    border-radius: 6px;
    overflow: hidden;
  }
  .photo .img:nth-child(-n+4){
    margin-top: 0;
  }
  .photo .img:nth-child(4n){
    margin-right: 0;
  }
  .photo .img img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000000;
  }

  .topping{
    margin-bottom: 30px;
    background: #ffffff;
  }
  .topping a:hover{
    opacity: 1;
  }
  .topping .img{
    position: relative;
    width: 790px;
    height: 474px;
    overflow: hidden;
  }
  .topping .img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .topping .img .length{
    position: absolute;
    right: 15px;
    bottom: 26px;
    color: #ffffff;
  }
  .topping .info-box{
    position: relative;
    padding: 30px;
    width: 410px;
    height: 474px;
  }
  .topping .info-box .date{
    margin-top: 15px;
    font-size: 12px;
    color: #424753;
  }
  .topping .info-box .date .ident{
    display: inline-block;
    margin-right: 14px;
    padding: 2px 4px;
    color: #ffffff;
    background: #FF3535;
    border-radius: 2px;
  }
  .topping .info-box .date .ident i{
    display: inline-block;
    margin-right: 3px;
    margin-top: -2px;
    width: 13px;
    height: 13px;
    vertical-align: middle;
    background-position: -673px -1238px;
  }
  .topping .info-box .tag{
    margin-top: 15px;
  }
  .topping .info-box .tag li{
    float: left;
  }
  .topping .info-box .tag li span{
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 3px 10px;
    color: #424753;
    background: #F0F0F0;
    border-radius: 2px;
  }
  .topping .info-box .summary{
    margin-top: 15px;
    max-height: 200px;
    line-height: 20px;
    font-size: 12px;
    color: #424753;
    opacity: 0.6;
    overflow: hidden;
  }
  .topping .info-box .opera{
    position: absolute;
    bottom: 30px;
  }
  .topping .info-box .opera .edit{
    margin-right: 15px;
    color: #424753;
  }
  .topping .info-box .opera .delete{
    color: #424753;
    opacity: .6;
  }

  .case{
    margin: 0 0 30px 30px;
    width: 380px;
    background: #FFFFFF;
    cursor: pointer;
  }
  .case:nth-child(3n+1){
    margin-left: 0px;
  }
  .case .imgbox{
    position: relative;
    height: 304px;
    overflow: hidden;
  }
  .panel .case .imgbox{
    height: 214px;
  }
  .case .imgbox img{
    width: 100%;
    height: 304px;
    object-fit: cover;
  }
  .panel .case .imgbox img{
    height: 214px;
  }
  .case .imgbox .img .length{
    position: absolute;
    right: 15px;
    bottom: 10px;
    color: #ffffff;
    z-index: 100;
  }
  .case .imgbox .bg{
    position: absolute;
    top: 0;
    padding: 15px;
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-size: 12px;
    background: rgba(13,20,37,.6);
    border-radius: 2px;
  }
  .case .imgbox .summary{
    opacity: 0;
    transition: all .5s;
  }
  .case .imgbox .state{
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
  }
  .case .imgbox .state .audit{
    margin-top: 85px;
  }
  .case .imgbox .state .audit i{
    margin-right: 4px;
    width: 18px;
    height: 18px;
    background-position: -771px -1209px;
  }
  .case .imgbox .state .fail{
    margin-top: 46px;
  }
  .case .imgbox .state .fail i{
    margin-right: 4px;
    width: 18px;
    height: 18px;
    background-position: -771px -1209px;
  }
  .case .info-box .info{
    padding: 12px 15px;
    border-bottom: 1px solid #EFEFEF;
  }
  .case .info-box .info .h3{
    color: #424753;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .case .info-box .info .tag{
    margin-top: 6px;
    font-size: 12px;
    color: #5E6370;
  }
  .case .info-box .info ul.tag span{
    margin-right: 5px;
    display: inline-block;
    padding: 3px 10px;
    background: #F0F0F0;
    border-radius: 2px;
  }
  .case .info-box .info div.tag span{
    margin-right: 10px;
  }
  .case .info-box .date{
    padding: 17px 20px 17px 15px;
    color: #424753;
  }
  .case .info-box .date span{
    opacity: .6;
  }
  .case .info-box .date .opera a{
    margin-left: 10px; color: #424753;
  }
  .case .info-box .date .opera .delete{
    opacity: .6;
  }
  .case:hover .info-box .info .h3 a{
    color: #3E87FF;
  }
  .case:hover .imgbox .summary{
    opacity: 1;
  }
  .pages{
    padding: 30px;
    text-align: center;
  }

  .data {
    padding: 35px 20px 100px;
    background: #ffffff;
  }
  .data .left,.data .right{
    width: 580px;
  }
  .data .right{
    padding: 0 20px 0 90px;
  }
  .data .title{
    position: relative;
    margin-bottom: 20px;
    padding-left: 15px;
    font-size: 20px;
    font-weight: 600;
  }
  .data .title:after{
    content: "";
    display: inline-block;
    position: absolute;
    left: 0;
    top: 3px;
    width: 4px;
    height: 24px;
    background-image: linear-gradient(46deg, #3067EC 0%, #15B2FF 100%);

  }
  .data .ain .tips{
    color: #FF5555;
    font-size: 12px;
    font-weight: normal;
  }
  .data .ain .cont{
    margin-bottom: 30px;
    max-height: 328px;
    line-height: 30px;
    opacity: 0.8;
    word-break: break-word;
    overflow: hidden;
  }
  .data .base .cont .div50{
    width: 50%;
  }
  .data .base .cont>div>div{
    margin-bottom: 20px;
  }
  .data .base .cont span{
    display: inline-block;
    margin-right: 30px;
    width: 44px;
    opacity: 0.5;
  }
  .data .works .item{
    position: relative;
    margin-bottom: 26px;
  }
  .data .works .item .wt{
    margin-bottom: 10px;
    line-height: 25px;
    font-size: 14px;
    overflow: hidden;
  }
  .data .works .item .wb{
    line-height: 25px;
    font-size: 12px;
    opacity: 0.6;
  }
  .data .works .item .wb div{
    float: left;
    width: 150px;
  }
  .data .works .item .del{
    display: inline-block;
    position: absolute;
    top: 5px;
    right: -25px;
    width: 17px;
    height: 17px;
    cursor: pointer;
    background: url("../../assets/images/5410.png");
  }
  .data .works .item .del:hover{
    background: url("../../assets/images/5411.png");
  }

  .pane-accinfo{
    background: #ffffff;
  }
  .pane-accinfo .head{
    padding: 18px 20px;
    border-bottom: 1px solid #F5F5F5;
  }
  .pane-accinfo .head span{
    font-size: 16px;
    font-weight: 600;
  }
  .pane-accinfo .head .buttons{
    margin-top: -3px;
  }
  .pane-accinfo .cont{
    padding: 20px;
  }
  .pane-accinfo .cont>div{
    width: 50%;
  }
  .cell {
    padding: 10px 0;
    line-height: 25px;
  }
  .cell>span:nth-child(1){
    display: inline-block;
    width: 112px;
    vertical-align: top;
  }
  .cell>span:nth-child(2){
    display: inline-block;
    width: 460px;
    word-wrap:break-word;
  }
  .cell>span>div>span:nth-child(1){
    display: inline-block;
    width: 102px;
  }

  .protocol{
    padding: 50px;
    text-align: center;
    background: #ffffff;
  }
  .protocol .text{
    margin-bottom: 30px;
    font-size: 16px;
    line-height: 29px;
  }
  .protocol .qrimg img{
    display: inline-block;
    width: 200px;
    height: 200px;
  }
  .protocol .opera{
    margin-top: 40px;
  }
  .protocol .opera .btn{
    padding: 0;
    width: 120px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }
  .protocol .opera .btn-empty{
    color: #3E87FF;
    border-color: #3E87FF;
  }
  .protocol .opera .btn-red{
    background: #FF4D4D;
  }

  .empty{
    padding: 80px 0;
    text-align: center;
    background: #ffffff;
  }
  .empty .etitle{
    margin: 20px 0 10px;
    font-size: 20px;
    font-weight: 600;
  }
</style>
<style>
  .modal.photo .btn-file{
    width: 150px;
    height: 266px;
  }
  .modal.photo .btn-file .hover .btn:nth-child(1){
    margin-top: 88px;
  }
  .modal.photo .btn-file .hover .btn:nth-child(2){
    margin-top: 20px;
  }
  .modal.photo .btn-file .text{
    color: #B8B8B8;
  }
  .modal.photo .btn-file .text i{
    margin-top: 95px;
  }
  .modal.photo .imgs{
    position: relative;
    margin: 22px 22px 0 0;
  }
  .modal.photo .imgs:nth-child(-n+5){
    margin-top: 0;
  }
  .modal.photo .imgs:nth-child(5n){
    margin-right: 0;
  }
  .modal.photo .imgs img{
    object-fit: contain;
    background: #000000;
  }
  .modal.photo .foot{
    margin-top: 16px;
    text-align: center;
  }

  .ivu-date-picker .ivu-input {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
  }
  .ivu-date-picker input{
    width: 100%;
  }

  .ivu-select .ivu-select-selection {
    height: 32px;
    line-height: 32px;
  }
  .ivu-select .ivu-select-selection .ivu-select-placeholder {
    height: 32px;
    line-height: 32px;
  }
  .ivu-select .ivu-select-selection .ivu-select-selected-value {
    height: 32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?22c698b5